import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';

import Ctas from '../../../Core/Ctas';

export const StyledCtas = styled(Ctas)`
  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin: 2rem auto 0;
  }
`;

export const Wrapper = styled.section`
  text-align: center;
  margin: auto;
`;

export const Heading = styled.h2`
  margin: auto;
  margin-bottom: 30px;
  max-width: 1200px;
  width: calc(100% - ${themeGet('media.grid-gutter.2')});

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    width: calc(100% - ${themeGet('media.grid-gutter.4')});
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    width: calc(100% - ${themeGet('media.grid-gutter.5')});
  }
`;

export const ContentWrapper = styled.div``;

export const Disclaimer = styled.p`
  margin-top: 2.5rem;
  font-size: 1.25rem;
  font-weight: ${themeGet('fontWeights.medium')};
`;
